"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecretString = void 0;
// Inspiration taken from Rust's SecretString: https://docs.rs/secrecy/latest/secrecy/type.SecretString.html
// Just without the ability to zeroize the bytes.
class SecretString {
    constructor(value) {
        this.value = value;
    }
    exposeSecret() {
        return this.value;
    }
    setRawSecret(rawSecret) {
        this.value = rawSecret;
    }
    toString() {
        return "***<Secret Redacted>***";
    }
    toJson() {
        return "***<Secret Redacted>***";
    }
}
exports.SecretString = SecretString;
